import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
    loading: false,
    courses: {
        course: [],
        order: "asc",
        orderBy: "",
        limit: 50,
        search: "",
        count: 0,
        offset: 0
    },
    courseToDelete: null
};

const CourseReducerSlice = createSlice({
    name: "course",
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload || false;
        },
        setCourses: (state, action) => {
            state.courses = {
                ...state.courses,
                ...action.payload,
            };
        },
        setCourseToDelete(state, action) {
            state.courseToDelete = action.payload;
        },
        deleteCourse(state, action) {
            state.courses.course = state.courses.course.filter(
                (c: { id: any; }) => c.id !== action.payload
            );
        }
    }
});

export const {
    setLoading,
    setCourses,
    deleteCourse,
    setCourseToDelete
} = CourseReducerSlice.actions;

export default CourseReducerSlice.reducer;
